import type { CountryCode } from "libphonenumber-js";
import parsePhoneNumberFromString from "libphonenumber-js";
import type { FocusEvent } from "react";
import { useFormContext } from "react-hook-form";

import { cn } from "@/lib/utils";

import type { AddressFormFields } from "../Checkout.types";
import type { CheckoutTextInputProps } from "../CheckoutTextInput";
import CheckoutTextInput from "../CheckoutTextInput";

export default function CheckoutPhoneNumberInput({
  className,
  label,
  ...props
}: Omit<CheckoutTextInputProps, "name" | "type">) {
  const { getValues, setValue } = useFormContext<AddressFormFields>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    const { phoneNumber, country } = getValues();
    const parsed = parsePhoneNumberFromString(
      phoneNumber,
      country?.toUpperCase() as CountryCode,
    );

    if (parsed && parsed.isValid()) {
      setValue("phoneNumber", parsed.format("E.164"), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <CheckoutTextInput
      className={cn("", className)}
      label={label}
      name="phoneNumber"
      type="tel"
      onBlur={handleBlur}
      {...props}
    />
  );
}
